import { Link } from "react-router-dom"
import { BoxButtom } from "../../styles/styles"
import { BsChevronDoubleLeft, BsChevronDoubleRight } from "react-icons/bs";
import './styles.css'
const ButtonFormFooter = ({ typeButtonNext, linkBack, iconNext, textNext, iconBack }) => {
    return (
        <BoxButtom>
            <Link className="link-form" to={linkBack ?? ''}>
                <div className="link-footer-button">
                    <div className="icon-footer-form">
                    <BsChevronDoubleLeft size={30} color='red' />
                    </div>
                    <p className="text-footer-form"> voltar</p>
                </div>
            </Link>

            <button className="link-footer-button">
                <p className="text-footer-form">{textNext}</p>
                <div className="icon-footer-form">
                <BsChevronDoubleRight size={30} color='green' />
                </div>
                


            </button>
        </BoxButtom>
    )
}
export default ButtonFormFooter